import { Roles } from "../../constants/user";
import { FormConfig } from "../../types/form";
import { queryBannerFields } from "../fields";

export const userManagementForm = (
  userRoles: Roles,
  fieldProps?: {
    portalRegions?: Array<any>;
    userStatuses?: Array<any>;
  }
): FormConfig => {
  const config = {
    fields: [queryBannerFields.emailAddress],
  };

  if (fieldProps?.userStatuses && fieldProps.userStatuses.length > 0) {
    const userStatusesField: any = queryBannerFields.status;

    userStatusesField.options = [
      {
        displayText: "All statuses",
        value: "",
      },
    ];

    fieldProps.userStatuses.forEach((userStatus) => {
      userStatusesField.options.push({
        displayText: userStatus.statusName,
        value: userStatus.status,
      });
    });

    config.fields.push(queryBannerFields.status);
  }

  if (fieldProps?.portalRegions && fieldProps.portalRegions.length > 0) {
    const portalRegionsField: any = queryBannerFields.portalRegion;

    portalRegionsField.options = fieldProps.portalRegions.map(
      (portalRegion) => ({
        displayText: portalRegion.portalHubName,
        value: portalRegion.cmsId,
      })
    );

    config.fields.push(portalRegionsField);
  }

  return config;
};
